/** Keep page and question facts small and strip URL query values before model use. */
export function boundedRealtimeVoiceContextText(
  value: string | null | undefined,
  limit: number
): string | undefined {
  const text = value
    ?.replace(/(?:https?:\/\/|\/)[^\s]*\?[^\s]*/giu, ' ')
    .replace(/\?[A-Za-z_][A-Za-z0-9_-]*=[^\s]*/gu, ' ')
    .replace(/[\p{Cc}\p{Cf}]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return text ? text.slice(0, limit) : undefined;
}
